import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  display: flex;

  width: 57rem;

  &:not(:last-of-type) {
    margin-bottom: 0.3rem;
  }
`;

const Label = styled.p`
  margin-left: 0.5rem;

  color: ${pickColor('greenStatus')};
`;

export { Container, Label };
